import React from 'react';

import Region from './Region';
import UnstyledList from './styled-components/UnstyledList';

/** @param {{regions: string[]}} */
const RegionList = ({ regions }) => (
  <UnstyledList>
    {regions?.map((region) => (
      <li key={region}>
        <Region>{region}</Region>
      </li>
    ))}
  </UnstyledList>
);

export default RegionList;
